import './ModifyRequestFormComponent.scss';
import {Field, FieldProps, Form, Formik, FormikHelpers} from "formik";
import React, {useCallback, useEffect, useState} from "react";
import FormDebuggerComponent from "../../../../shared/components/form-debugger/FormDebuggerComponent";
import FormikSelectDropdownComponent
    from "../../../../shared/components/form-controls/formik-select-dropdown/FormikSelectDropdownComponent";
import AccordionComponent from "../../../../shared/components/accordion/accordionComponent";
import FormikRadioButtonComponent
    from "../../../../shared/components/form-controls/formik-radio-button/formikRadioButtonComponent";
import {CommonService} from "../../../../shared/services";
import ButtonComponent from "../../../../shared/components/button/ButtonComponent";
import * as Yup from "yup";
import {useSelector} from "react-redux";
import {IRootReducerState} from "../../../../store/reducers";
import _ from "lodash";
import {IAPIResponseType} from "../../../../shared/models/api.model";
import {API_RESPONSE_MESSAGE_KEY} from "../../../../constants/Misc";

interface ModifyRequestFormComponentProps {
    selectedProfile: any;
    isApproveClientRequestLoading: boolean;
    selectedOption: any;
    approveClientRequest: any;
    rejectClientRequest: any;
    closeDrawer?: any;
}

const mutual_access_object = {
    title: "Mutual Access",
    code: "mutual",
}

const no_mutual_access_object = {
    title: "No Mutual Access",
    code: "non_mutual",
}

const accountDetailFormValidationSchema = Yup.object().shape({
    permission_type: Yup.mixed().required('Permission type is required'),
});

const accountDetailInitialValues = {
    permission_type: "",
    relationship: ''
}

const ModifyRequestFormComponent = (props: ModifyRequestFormComponentProps) => {

    const {
        selectedProfile,
        selectedOption,
        rejectClientRequest,
        // approveClientRequest,
        // isApproveClientRequestLoading,
        closeDrawer,
    } = props;
    const {relationshipList} = useSelector((state: IRootReducerState) => state.staticData);
    const [accountDetailFormInitialValues, setAccountDetailsFormInitialValues] = useState<any>(_.cloneDeep(accountDetailInitialValues));
    const [isModifyRequestLoading, setIsModifyRequestLoading] = useState(false);

    useEffect(() => {
        if (selectedProfile) {
            setAccountDetailsFormInitialValues({
                permission_type: selectedProfile.permission_type
            });

        }
    }, [selectedProfile]);

    const modifyPermission = useCallback((values: any, {setSubmitting, setErrors}: FormikHelpers<any>): void => {
        setIsModifyRequestLoading(true);
        const payload = {
            ...values,
        }
        CommonService._client.editProfileLinking(selectedProfile?._id, payload)
            .then((response: IAPIResponseType<any>) => {
                CommonService._alert.showToast(response[API_RESPONSE_MESSAGE_KEY], 'success')
                setIsModifyRequestLoading(false);
                closeDrawer();
            }).catch((error: any) => {
            CommonService.handleErrors(setErrors, error);
            setIsModifyRequestLoading(false);
            closeDrawer();
        });

    }, [closeDrawer,selectedProfile]);


    return (
        <div className="modify-request-form-component">
            <>
                <Formik
                    validationSchema={accountDetailFormValidationSchema}
                    initialValues={accountDetailFormInitialValues}
                    validateOnChange={false}
                    validateOnBlur={true}
                    enableReinitialize={true}
                    validateOnMount={true}
                    onSubmit={modifyPermission}
                >
                    {({values, validateForm, isValid, isSubmitting, dirty}) => {
                        // eslint-disable-next-line react-hooks/rules-of-hooks
                        useEffect(() => {
                            validateForm();
                        }, [validateForm, values, dirty]);
                        return (
                            <Form className="t-form" noValidate={true}>
                                <FormDebuggerComponent values={values} showDebugger={false}/>
                                <div className="t-form-controls">
                                    <div className="assign-relationship-wrapper">Assign Relationship</div>
                                    <div className={'pdd-bottom-15'}>Choose how you are connected to the above mentioned
                                        profile
                                    </div>
                                    <Field name={'relationship'}>
                                        {
                                            (field: FieldProps) => (
                                                <FormikSelectDropdownComponent
                                                    options={relationshipList}
                                                    placeholder={'Select Relationship'}
                                                    formikField={field}
                                                    fullWidth={true}
                                                    isClearable={false}
                                                />
                                            )
                                        }
                                    </Field>
                                    <div className="permissions-heading">Permissions</div>
                                    <AccordionComponent
                                        title={<Field name={'permission_type'}>
                                            {
                                                (field: FieldProps) => (
                                                    <FormikRadioButtonComponent
                                                        displayWith={(option: any) => `${CommonService.capitalizeFirstLetter(option?.title)}`}
                                                        valueExtractor={(option: any) => option.code}
                                                        keyExtractor={(option: any) => option.code}
                                                        option={mutual_access_object}
                                                        formikField={field}
                                                        required={true}
                                                    />
                                                )
                                            }
                                        </Field>}
                                    >
                                        <div className="mutual-access-content-wrapper-2">
                                            <p className={'pdd-bottom-20'}>This Permission:</p>
                                            <ul className={'permission-type-text pdd-left-15 pdd-bottom-15'}>
                                                <li className={'pdd-bottom-15'}>Gives the other person
                                                    access to your
                                                    account to book appointments and manage
                                                    your
                                                    account on your behalf.
                                                </li>
                                                <li className={' pdd-bottom-15'}>Gives you access to
                                                    their account to
                                                    book appointments and manage their
                                                    account.
                                                </li>
                                                <li className={'pdd-bottom-15'}>Can be rescinded at any
                                                    time.
                                                </li>
                                            </ul>
                                        </div>
                                    </AccordionComponent>
                                    <div className="pdd-top-20">
                                        <AccordionComponent
                                            title={<Field name={'permission_type'}>
                                                {
                                                    (field: FieldProps) => (
                                                        <FormikRadioButtonComponent
                                                            displayWith={(option: any) => `${CommonService.capitalizeFirstLetter(option?.title)}`}
                                                            valueExtractor={(option: any) => option.code}
                                                            keyExtractor={(option: any) => option.code}
                                                            option={no_mutual_access_object}
                                                            formikField={field}
                                                            required={true}
                                                        />
                                                    )
                                                }
                                            </Field>}
                                        >
                                            <div className="mutual-access-content-wrapper">
                                                <p className={'pdd-bottom-20'}>This Permission:</p>
                                                <ul className={'permission-type-text pdd-left-15 pdd-bottom-15'}>
                                                    <li className={'pdd-bottom-15'}>Denies the other person
                                                        permission to access your account.
                                                    </li>
                                                    <li className={'pdd-bottom-15'}>Can be changed at any
                                                        time.
                                                    </li>
                                                </ul>
                                            </div>
                                        </AccordionComponent>
                                    </div>

                                </div>
                                <div className="d-flex t-form-actions">
                                    <ButtonComponent
                                        color={'accent'}
                                        variant={'outlined'}
                                        // isLoading={isRejectRequestLoading}
                                        disabled={(!selectedOption)}
                                        onClick={() => rejectClientRequest()}
                                    >
                                        Reject
                                    </ButtonComponent>
                                    <ButtonComponent
                                        color={'accent'}
                                        type={'submit'}
                                        className={'mrg-left-20'}
                                        isLoading={isModifyRequestLoading}
                                        variant={'contained'}>
                                        Approve
                                    </ButtonComponent>
                                </div>
                            </Form>
                        )
                    }}
                </Formik>
            </>
        </div>
    )

}

export default ModifyRequestFormComponent;
